import { Component } from '@angular/core';

@Component({
  selector: 'app-sdmp-sidebar',
  templateUrl: './sdmp-sidebar.component.html',
  styleUrls: ['./sdmp-sidebar.component.scss']
})
export class SdmpSidebarComponent {

}